module.exports = __webpack_public_path__ + "img/drone-montagne-lazy.ab56da98.jpg";